import { SelectProps, SelectVariants } from '@mui/material';
import React, { useEffect } from 'react';
import { SelectorLayout, SelectorTypes } from '../SelectorLayout';
import { useWorkLocationsList } from '../useSelectorQuery';

interface Props extends Omit<SelectProps<string>, 'onChange' | 'variant'> {
  onChange: (workLocations?: string) => void;
  variant?: SelectVariants;
}

export const WorkLocationsSelector: React.FC<Props> = ({ onChange, sx, value, ...props }) => {
  const { workLocations } = useWorkLocationsList();
  useEffect(() => {
    if (!workLocations?.find(location => location === value)) {
      onChange(undefined);
    }
  }, [workLocations, onChange, value]);
  return (
    <SelectorLayout
      selectorType={SelectorTypes.WORK_LOCATIONS}
      selectorData={workLocations}
      onChange={onChange}
      sx={sx}
      value={value}
      {...props}
    />
  );
};
